package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.braunequip.web.components.models.ContactsDTO
import org.braunequip.web.components.models.TimeOffRequestDTO
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.braunequip.web.util.submitContact
import org.braunequip.web.util.submitTimeOffRequest
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun TimeOffForm(
    scope: CoroutineScope,
    onFinish: () -> Unit
) {
    var errorText by remember { mutableStateOf(" ") }
    var TimeOffFormState by remember { mutableStateOf(TimeOffRequestDTO()) }

    H3(Modifier.classNames("title", "is-3", "has-text-dark").toAttrs()) {
        Text("Time Off Request Form")
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .gap(20.px)
    ) {
        Input(
            type = InputType.Text,
            attrs = Modifier
                .id(InputIDs.TimeOffForm.firstname)
                .fillMaxWidth()
                .height(54.px)
                .margin(topBottom = 12.px)
                .padding(leftRight = 20.px)
                .backgroundColor(Theme.LightGray.rgb)
                .borderRadius(r = 4.px)
                .border(
                    width = 1.px,
                    style = LineStyle.Solid,
                    color = Colors.Black
                )
                .fontFamily(FONT_FAMILY)
                .fontSize(16.px)
                .toAttrs {
                    attr("placeholder", "First Name*")
                }
        )

        Input(
            type = InputType.Text,
            attrs = Modifier
                .id(InputIDs.TimeOffForm.middlename)
                .fillMaxWidth()
                .height(54.px)
                .margin(topBottom = 12.px)
                .padding(leftRight = 20.px)
                .backgroundColor(Theme.LightGray.rgb)
                .borderRadius(r = 4.px)
                .border(
                    width = 1.px,
                    style = LineStyle.Solid,
                    color = Colors.Black
                )
                .fontFamily(FONT_FAMILY)
                .fontSize(16.px)
                .toAttrs {
                    attr("placeholder", "Middle Name")
                }
        )

        Input(
            type = InputType.Text,
            attrs = Modifier
                .id(InputIDs.TimeOffForm.lastname)
                .fillMaxWidth()
                .height(54.px)
                .margin(topBottom = 12.px)
                .padding(leftRight = 20.px)
                .backgroundColor(Theme.LightGray.rgb)
                .borderRadius(r = 4.px)
                .border(
                    width = 1.px,
                    style = LineStyle.Solid,
                    color = Colors.Black
                )
                .fontFamily(FONT_FAMILY)
                .fontSize(16.px)
                .toAttrs {
                    attr("placeholder", "Last Name*")
                }
        )
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Input(
            type = InputType.Text,
            attrs = Modifier
                .id(InputIDs.TimeOffForm.email)
                .fillMaxWidth()
                .height(54.px)
                .margin(topBottom = 12.px)
                .padding(leftRight = 20.px)
                .backgroundColor(Theme.LightGray.rgb)
                .borderRadius(r = 4.px)
                .border(
                    width = 1.px,
                    style = LineStyle.Solid,
                    color = Colors.Black
                )
                .fontFamily(FONT_FAMILY)
                .fontSize(16.px)
                .toAttrs {
                    attr("placeholder", "Email*")
                }
        )
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Input(
            type = InputType.Text,
            attrs = Modifier
                .id(InputIDs.TimeOffForm.phone)
                .fillMaxWidth()
                .height(54.px)
                .margin(topBottom = 12.px)
                .padding(leftRight = 20.px)
                .backgroundColor(Theme.LightGray.rgb)
                .borderRadius(r = 4.px)
                .border(
                    width = 1.px,
                    style = LineStyle.Solid,
                    color = Colors.Black
                )
                .fontFamily(FONT_FAMILY2)
                .fontSize(16.px)
                .toAttrs {
                    attr("placeholder", "Phone Number")
                }
        )
    }

    HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

    Row(
        modifier = Modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Start Date*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Date,
                attrs = Modifier
                    .id(InputIDs.TimeOffForm.startdate)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs()
            )
        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "End Date*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Date,
                attrs = Modifier
                    .id(InputIDs.TimeOffForm.enddate)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs()
            )
        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Return Date*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Date,
                attrs = Modifier
                    .id(InputIDs.TimeOffForm.returndate)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs()
            )
        }
    }

    HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            SpanText(
                text = "Reason*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.TimeOffForm.reason)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "ex. Vacation, Personal, Vacation, Sick, other")
                    }
            )
        }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Use PTO if available?*",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontWeight(FontWeight.Bold)
            )

            Input(
                type = InputType.Checkbox,
                attrs = Modifier
                    .id(InputIDs.TimeOffForm.usepto)
                    .height(30.px)
                    .width(30.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(16.px)
                    .toAttrs()
            )

        }
    }


    TextArea(
        attrs = Modifier
            .id(InputIDs.TimeOffForm.message)
            .fillMaxWidth()
            .height(175.px)
            .maxHeight(400.px)
            .margin(top = 8.px)
            .padding(all = 20.px)
            .backgroundColor(Theme.LightGray.rgb)
            .borderRadius(4.px)
            .fontFamily(FONT_FAMILY)
            .fontSize(16.px)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = Colors.Black
            )
            .resize(Resize.None)
            .toAttrs{
                attr("placeholder", "Brief Description")
            }
    )

    SpanText(
        modifier = Modifier
            .width(350.px)
            .margin(top = 1.cssRem)
            .fontFamily(FONT_FAMILY2)
            .color(Colors.Black)
            .textAlign(TextAlign.Center),
        text = errorText
    )


    SubmitButton(
        text = "SUBMIT",
        onClick = {
            TimeOffFormState = TimeOffFormState.copy(
                employeeFirstName = (document.getElementById(InputIDs.TimeOffForm.firstname) as HTMLInputElement).value,
                employeeMiddleName = (document.getElementById(InputIDs.TimeOffForm.middlename) as HTMLInputElement).value,
                employeeLastName = (document.getElementById(InputIDs.TimeOffForm.lastname) as HTMLInputElement).value,
                employeeEmail = (document.getElementById(InputIDs.TimeOffForm.email) as HTMLInputElement).value,
                employeeContactNumber = (document.getElementById(InputIDs.TimeOffForm.phone) as HTMLInputElement).value,
                requestStartDate = (document.getElementById(InputIDs.TimeOffForm.startdate) as HTMLInputElement).value,
                requestEndDate = (document.getElementById(InputIDs.TimeOffForm.enddate) as HTMLInputElement).value,
                requestReturnDate = (document.getElementById(InputIDs.TimeOffForm.returndate) as HTMLInputElement).value,
                reason = (document.getElementById(InputIDs.TimeOffForm.reason) as HTMLInputElement).value,
                usePtoQuestion = (document.getElementById(InputIDs.TimeOffForm.usepto) as HTMLInputElement).checked,
                description = (document.getElementById(InputIDs.TimeOffForm.message) as HTMLTextAreaElement).value,
            )

            if (
                TimeOffFormState.employeeFirstName.isNotEmpty() &&
                TimeOffFormState.employeeLastName.isNotEmpty() &&
                TimeOffFormState.employeeEmail.isNotEmpty() &&
                TimeOffFormState.requestStartDate.isNotEmpty() &&
                TimeOffFormState.requestEndDate.isNotEmpty() &&
                TimeOffFormState.requestReturnDate.isNotEmpty() &&
                TimeOffFormState.reason.isNotEmpty()
            ) {
                scope.launch {
                    submitTimeOffRequest(
                        TimeOffFormState,
                    ) { finishText ->
                        errorText = finishText
                    }
                    delay(1000)
                    onFinish()
                }
            } else {
                errorText = "Please fill out all required fields."
            }

        }
    )



}